import React, { useState, useEffect } from 'react'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { Mutation } from 'react-apollo'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import moment from 'moment'
import FileDownload from 'js-file-download'
import axios from 'axios'
import {
  message, Modal, Select, Icon, Menu, Dropdown, Button, Radio, DatePicker,
} from 'antd'
import {
  SmallText, Div, Button as KonsysButton, Input,
} from 'konsys-ui'
import numeral from 'numeral'
import { UPDATE_INVOICE, DELETE_INVOICE, SYNC_INVOICE } from '../../constants/graphql/mutation'
import { INVOICE_INFO, GET_CLIENTS } from '../../constants/graphql/query'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { status, statusText } from '../../pages/invoice-page/constants'
import { P } from '../../pages/invoice-page/styled'
import {
  MethodButton, EachInput, DatePicker as DP, TaxSelect,
} from './styled'
import PERMISSION from '../../constants/permissions'
import { getAccessToken, getURL } from '../../utils/local-data-service'
import { checkFloat } from '../../utils/util-services'

const { color } = theme

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange, value }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)} value={value} />
)

export const StatusSelector = ({
  handleChange, filter, disabled,
}) => {
  const arr = [
    { value: status.WAITING, text: statusText.WAITING },
    { value: status.OVERDUE, text: statusText.OVERDUE },
    { value: status.BILLED, text: statusText.BILLED },
    { value: status.BILLANDOVERDUE, text: statusText.BILLANDOVERDUE },
    { value: status.PARTIAL, text: statusText.PARTIAL },
    { value: status.PAID, text: statusText.PAID },
  ]

  const filterer = filter ? _.concat({ value: 'ALL', text: 'ทั้งหมด' }, arr) : arr

  return (
    <Select
      disabled={disabled}
      dropdown
      style={{ width: 130 }}
      defaultValue="ทั้งหมด"
      onChange={e => handleChange(e)}
    >
      {
        filterer.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
      }
    </Select>
  )
}

const menu = (original, setPaidModal, refetch) => {
  const [doSyncPeak] = useMutation(SYNC_INVOICE)
  return (
    <Div>
      <Mutation
        mutation={DELETE_INVOICE}
      >{doCancel => (
        <Menu selectedKeys={[null]}>
          <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_INVOICE)}>
            <Link target="_blank" to={`/invoice/view/${original.id}`}>
              ดูรายละเอียด
                </Link>
          </Menu.Item>
          <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_INVOICE)}>
            <Link target="_blank" to={`/invoice/edit/${original.id}`}>
              แก้ไข
                </Link>
          </Menu.Item>
          <Menu.Item
            key='syncPeak'
            disabled={
              !_.includes(window.perms, PERMISSION.CREATE_BILL)
              || (original.status !== status.WAITING && original.status !== status.OVERDUE)
            }
            onClick={() => {
              doSyncPeak({
                variables: { id: original.id },
              }).then((res) => {
                if (res.data.SyncInvoice.success) {
                  message.success(res.data.SyncInvoice.message)
                  refetch()
                } else message.error(res.data.SyncInvoice.message)
              })
            }}
          >
            ส่งข้อมูลไป PEAK
          </Menu.Item>
          {
            window.role === 'SuperAdmin' && !(original.status === status.PAID || original.status === status.PARTIAL)
            && <Menu.Item key='update'>
              <Link target="_blank" to={`/invoice/update/${original.id}`}>
                เพิ่ม/ลดใบสั่งบรรทุก
                  </Link>
            </Menu.Item>
          }
          {
            (original.status === status.WAITING || original.status === status.OVERDUE || original.status === status.PARTIAL)
            && <Menu.Item
              key='collect'
              disabled={!_.includes(window.perms, PERMISSION.RECEIVE_PAYMENT_INVOICE)}
            >
              <Link target="_blank" to={`/invoice/paid/${original.id}`}>
                เก็บเงิน
                  </Link>
            </Menu.Item>
          }
          {
            (original.status === status.WAITING || original.status === status.OVERDUE) && _.includes(window.perms, PERMISSION.UPDATE_INVOICE)
            && <Menu.Item
              style={{ color: theme.color.error }}
              key='cancel'
              disabled={!_.includes(window.perms, PERMISSION.UPDATE_INVOICE)}
              onClick={() => Modal.confirm({
                title: `คุณต้องการยกเลิกใบวางบิล / แจ้งหนี้เลขที่ ${original.refId}`,
                content: 'ถ้ายกเลิกแล้วจะไม่สามารถแก้ไขได้',
                cancelText: 'เก็บไว้',
                okText: 'ยกเลิกใบวางบิล / แจ้งหนี้',
                onCancel() {
                },
                onOk() {
                  doCancel({
                    variables: { id: original.id },
                  }).then((res) => {
                    if (res.data.DeleteInvoice.success) {
                      message.success(res.data.DeleteInvoice.message)
                      refetch()
                    } else message.error(res.data.DeleteInvoice.message)
                  })
                },
              })}
            >
              ยกเลิก
                </Menu.Item>
          }
        </Menu>
      )}
      </Mutation>
    </Div>
  )
}

export const LimitSelectors = ({ limit, setLimit, totalCount }) => {
  const limitList = [5, 10, 30, 50, 100, 300, 500]
  return (
    <Select
      dropdown
      style={{ width: 130 }}
      defaultValue="5"
      value={limit}
      onChange={(e) => {
        if (e > totalCount) {
          message.warning('จำนวนใบวางบิล / ใบแจ้งหนี้มีน้อยกว่าจำนวนที่เลือก')
          setLimit(totalCount)
        } else {
          setLimit(e)
        }
      }}
    >
      {
        limitList.map(v => <Select.Option key={v} value={v}>{v}</Select.Option>)
      }
    </Select>
  )
}

export const ActionSelectors = ({ props: { original }, refetch }) => {
  const [paidModal, setPaidModal] = useState(false)

  return (
    <Div>
      <Dropdown overlay={menu(original, setPaidModal, refetch)} trigger='click'>
        <Button>
          ดูรายละเอียด <Icon type="down" />
        </Button>
      </Dropdown>
      {/* <PaidModal id={original.id} paidModal={paidModal} setPaidModal={setPaidModal} refetch={refetch} info={original} /> */}
    </Div>
  )
}

export const ActionSelectorBAK = ({ props, refetch }) => {
  const [paidModal, setPaidModal] = useState(false)

  return (
    <Div>
      <Select
        value='ดูรายละเอียด'
        defaultValue="ดูรายละเอียด"
        onSelect={(e) => {
          if (e === 'collect') setPaidModal(true)
        }}>
        <Select.Option value="view">
          <Link to={`/invoice/view/${props.original.id}`}>
            ดูรายละเอียด
          </Link>
        </Select.Option>
        <Select.Option value="edit">
          <Link to={`/invoice/edit/${props.original.id}`}>
            แก้ไข
          </Link>
        </Select.Option>
        {
          (props.original.status === status.WAITING || props.original.status === status.OVERDUE)
          && <Menu.Item key='collect'>
            เก็บเงิน
          </Menu.Item>
        }
      </Select>
      {/* <PaidModal id={props.original.id} paidModal={paidModal} setPaidModal={setPaidModal} refetch={refetch} info={props.original} /> */}
    </Div>
  )
}

const taxList = [
  { value: 0, text: '0%' },
  { value: 0.5, text: '0.5%' },
  { value: 0.75, text: '0.75%' },
  { value: 1, text: '1%' },
  { value: 2, text: '2%' },
  { value: 3, text: '3%' },
  { value: 5, text: '5%' },
  { value: 10, text: '10%' },
  { value: 11.2, text: '11.2%' },
  { value: 13, text: '13%' },
  { value: 15, text: '15%' },
]

const convertTax = (value) => {
  switch (value) {
    case 0.5: return 'TYPE_05'
    case 0.75: return 'TYPE_075'
    case 1: return 'TYPE_1'
    case 2: return 'TYPE_2'
    case 3: return 'TYPE_3'
    case 5: return 'TYPE_5'
    case 10: return 'TYPE_10'
    case 11.2: return 'TYPE_11_2'
    case 13: return 'TYPE_13'
    case 15: return 'TYPE_15'
    default: return undefined
  }
}

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, unit, disabled, dealType, invoice, groupId,
}) => {
  const [modal, setModal] = useState(false)
  const [isLoading, setIsLoading] = useState([false, false])
  const [fuelCharge, setFuelCharge] = useState(0)
  if (props && props.totalFuelPrice && fuelCharge === 0) setFuelCharge(props.totalFuelPrice)
  const companyWithCustomPdf = [1, 2, 3, 5, 6, 7, 9, 10, 11, 12, 15, 17, 18]
  const urlSelector = (group, id, extra) => {
    const token = getAccessToken()
    switch (group) {
      case 1:
        return `render/pdf/type/1/${id}?t=${token}&billDate=${moment(extra).format('YYYY-MM-DD')}`
      case 2:
        if (dealType === 'PERTRIP') {
          return `render/pdf/type/2.2/${id}?t=${token}`
        } return `render/pdf/type/2.1/${id}?t=${token}`
      case 3:
        if (invoice.Job.Customer.id === 29 || invoice.Job.Customer.id === 4 || invoice.Job.Customer.id === 5) {
          return `render/pdf/type/3.3/${id}?t=${token}`
        }
        if (invoice.Job.Customer.id === 7) {
          return `render/pdf/type/3.4/${id}?t=${token}`
        }
        return `render/pdf/type/3.4/${id}?t=${token}`
      case 5:
        return `render/pdf/type/5.1/${id}?t=${token}`
      case 6:
        return `render/pdf/type/6.3/${id}?t=${token}`
      case 6.4:
        return `render/pdf/type/6.4/${id}?date=${extra}&t=${token}`
      case 7:
        if (dealType === 'PERTRIP') {
          return `render/pdf/type/7.3/${id}?cargoName=${extra}&t=${token}`
        } return `render/pdf/type/7.2/${id}?cargoName=${extra}&t=${token}`
      case 9:
        return `render/pdf/type/9/${id}?t=${token}`
      case 10:
        return `render/pdf/type/10.2/${id}?t=${token}`
      case 11:
        if (dealType === 'PERTRIP') {
          return `render/pdf/type/11.1/${id}?t=${token}`
        } return `render/pdf/type/11.2/${id}?t=${token}`
      case 12:
        return `render/pdf/type/12/${id}?bookingNo=${extra}&t=${token}`
      case 15:
        return `render/pdf/type/15/${id}?t=${token}`
      case 17:
        return `render/pdf/type/17/${id}?date=${extra}&t=${token}`
      case 18:
        return `render/pdf/type/18/${id}?startdate=${extra.startDate}&enddate=${extra.endDate}&fuelCharge=${Number(fuelCharge)}&t=${token}`
      default:
        return `render/pdf/type/0/${id}?t=${token}&headType=${extra}`
    }
  }
  const download = (group, id, type, extra) => {
    setIsLoading([false, true])
    const url = type === 1
      ? `${getURL().FILE_SERVER}/render/pdf/type/0/${id}?t=${getAccessToken()}&headType=${extra}` // choose padoongrich in modal
      : `${getURL().FILE_SERVER}/${urlSelector(group, id, extra)}` // choose customer in modal
    window.open(
      url,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    setIsLoading([false, false])
  }
  const downloadReceipt = (id, deal) => {
    setIsLoading([true, false])
    const token = getAccessToken()
    const url = deal === 'PERTRIP'
      ? `${getURL().FILE_SERVER}/downloadfile/pdf/padoongrichBillingTypeBilled/${id}?t=${token}` // trip
      : unit === 'TON' // weight
        ? `${getURL().FILE_SERVER}/downloadfile/pdf/padoongrichTonPdfTypeBilled/${id}?t=${token}`
        : `${getURL().FILE_SERVER}/downloadfile/pdf/padoongrichHbPdfTypeBilled/${id}?t=${token}`
    window.open(
      url,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    setIsLoading([false, false])
  }
  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton
        text='พิมพ์ใบเสร็จ'
        icon='fas fa-print'
        loading={isLoading[0]}
        disabled={isLoading[0] || !_.includes(window.perms, PERMISSION.PRINT_INVOICE) || isAddMode || invoice.status !== 'PAID'}
        onClick={() => {
          downloadReceipt(props.match.params.id, dealType)
        }}
      />
      <KonsysButton
        text='พิมพ์ใบวางบิล / ใบแจ้งหนี้'
        icon='fas fa-print'
        loading={!_.includes(companyWithCustomPdf, groupId) && isLoading[1]}
        disabled={!_.includes(window.perms, PERMISSION.PRINT_INVOICE) || isAddMode || (!_.includes(companyWithCustomPdf, groupId) && isLoading[1])}
        onClick={() => {
          if (_.includes(companyWithCustomPdf, groupId)) setModal(true)
          else download(groupId, props.match.params.id)
        }}
        margin='0 8px'
      />
      <KonsysButton
        loading={loading}
        disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_INVOICE)) || disabled}
        text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
        icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
        inverse
        onClick={() => {
          if (isViewMode) history.push(`/invoice/edit/${props.match.params.id}`)
          else {
            doAction({
              variables: isAddMode
                ? { ...mutationVariables, createdDate: moment().format() }
                : { ...mutationVariables, id: parseInt(props.match.params.id, 10), withHoldingTax: convertTax(mutationVariables.withHoldingTax) },
            }).then(({ data }) => {
              const resp = isAddMode ? data.CreateInvoice : data.UpdateInvoice

              if (resp.success) {
                message.success(resp.message)
                if (isAddMode) history.push('/invoice')
              } else message.error(resp.message)
            })
          }
        }}
      />
      <InvoicePrintModal
        props={props}
        isLoading={isLoading}
        download={download}
        modal={modal}
        setModal={setModal}
        invoice={invoice}
        groupId={groupId}
        dealType={dealType}
        fuelCharge={fuelCharge}
        setFuelCharge={setFuelCharge}
      />
    </Div>
  )
}

export const PaymentActionBar = ({
  loading, doAction, mutationVariables, props, disabled, isPartial, shippingsId, invoice, grandTotal, type,
}) => {
  const [modal, setModal] = useState(false)
  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton
        loading={loading}
        disabled={loading || !_.includes(window.perms, PERMISSION.RECEIVE_PAYMENT_INVOICE) || disabled}
        text='สร้างใหม่'
        icon='fas fa-plus'
        inverse
        onClick={() => {
          doAction({
            variables: {
              ...mutationVariables,
              withHoldingTax: convertTax(mutationVariables.withHoldingTax),
              shippingsId,
              isPartial,
              grandTotal,
              invoiceId: invoice.id,
              type,
            },
          }).then(({ data }) => {
            const resp = data.CreateInvoicePayment
            if (resp.success) {
              message.success(resp.message)
              history.push(`/invoice/view/${invoice.id}`)
            } else message.error(resp.message)
          })
        }}
      />
    </Div>
  )
}

const InvoicePrintModal = ({
  props, isLoading, download, modal, setModal, groupId, dealType, fuelCharge, setFuelCharge,
}) => {
  const [type, setType] = useState(1) // padoongrich = 1, customer = 2
  const [useCargoType, setUseCargoType] = useState(false)
  const [sugarMolasse, setSugarMolasse] = useState(1) // sugar = 1, molasse = 2
  const [productType, setProductType] = useState(1)
  const [booking, setBooking] = useState()
  const [date, setDate] = useState([])
  const [padoongrich, setPadoongrich] = useState(0)
  const [byMonth, setByMonth] = useState(0)
  const selectData = [
    { value: 1, text: 'ดิบเทกอง (ไฮโพล)' },
    { value: 2, text: 'น้ำตาลทรายดิบเทกอง J-SPEC' },
    { value: 3, text: 'น้ำตาลทรายดิบเทกอง M-SPEC' },
    { value: 4, text: 'น้ำตาลทรายดิบเทกอง HI-POL' },
    { value: 5, text: 'น้ำตาลทรายขาวธรรมดา  ( W1 )' },
    { value: 6, text: 'น้ำตาลทรายขาวธรรมดา  ( W2 )' },
    { value: 7, text: 'น้ำตาลทรายขาวธรรมดา  ( W3 )' },
    { value: 8, text: 'น้ำตาลทรายขาวธรรมดา  ( R )' },
    { value: 9, text: 'น้ำตาลทรายขาวบริสุทธิ์ ( R )' },
    { value: 10, text: 'น้ำตาลทรายขาวบริสุทธิ์ ( R1 )' },
    { value: 11, text: 'น้ำตาลทรายขาวบริสุทธิ์ ( R2 )' },
    { value: 12, text: 'น้ำตาลทรายขาวบริสุทธิ์ ( SRS )' },
    { value: 13, text: 'น้ำตาลทรายขาวบริสุทธิ์ R1 ( S18 )' },
    { value: 14, text: 'น้ำเชื่อมหวาน ( LIQUID SUCROSE )' },
    { value: 15, text: 'กระสอบน้ำตาลเก่า' },
    { value: 16, text: 'เงินค้ำประกัน' },
    { value: 17, text: 'น้ำตาลรีไฟน์' },
    { value: 18, text: 'น้ำตาลส่งคืนจากการ Reject' },
  ]
  return (
    <Modal
      title="เลือกรูปแบบใบวางบิล / ใบแจ้งหนี้"
      visible={modal}
      onCancel={() => {
        setType(1)
        setUseCargoType(false)
        setSugarMolasse(1)
        setProductType(1)
        setModal(false)
        setPadoongrich(0)
        setDate([])
        setByMonth(0)
        setBooking()
        setFuelCharge(0)
      }}
      onOk={() => {
        if (groupId === 12 && type === 2) {
          download(12, props.match.params.id, dealType, booking)
        } else if (useCargoType && sugarMolasse === 1) {
          download(7, props.match.params.id, dealType, _.filter(selectData, v => v.value === productType)[0].text)
        } else if (useCargoType && sugarMolasse === 2) {
          download(3, props.match.params.id)
        } else if (type === 1) {
          download(0, props.match.params.id, 1, padoongrich)
        } else if (groupId === 6 && byMonth === 1) {
          download(6.4, props.match.params.id, 2, date)
        } else if (_.includes([1, 17, 18], groupId)) {
          download(groupId, props.match.params.id, 2, date)
        } else {
          download(groupId, props.match.params.id)
        }
      }}
      okButtonProps={{
        loading: isLoading[1],
        disabled: isLoading[1] || (groupId === 12 && type === 2 && (_.isUndefined(booking) || _.isEmpty(booking))),
      }}
      cancelButtonProps={{
        disabled: isLoading[1],
      }}
    >
      <Div display='flex' flexDirection='column' alignItems='center'>
        <Radio.Group value={type} size="large" onChange={(e) => {
          if ((groupId === 3 || groupId === 7) && e.target.value === 2) {
            setUseCargoType(true)
          } else {
            setUseCargoType(false)
          } setType(e.target.value)
        }}>
          <Radio.Button value={1}>รูปแบบผดุงฤทธิ์</Radio.Button>
          <Radio.Button value={2}>รูปแบบลูกค้า</Radio.Button>
        </Radio.Group>
      </Div>
      {
        type === 1 && <Div display='flex' flexDirection='column' alignItems='center' margin='16px 0 0'>
          <Radio.Group value={padoongrich} size="large" onChange={e => setPadoongrich(e.target.value)}>
            <Radio.Button value={0}>ใบวางบิล</Radio.Button>
            <Radio.Button value={1}>ใบแจ้งหนี้</Radio.Button>
          </Radio.Group>
        </Div>
      }
      {
        useCargoType && <Div display='flex' flexDirection='column' alignItems='center' margin='16px 0 0'>
          <Radio.Group value={sugarMolasse} size="large" onChange={e => setSugarMolasse(e.target.value)}>
            <Radio.Button value={1}>น้ำตาล</Radio.Button>
            <Radio.Button value={2}>โมลาส</Radio.Button>
          </Radio.Group>
        </Div>
      }
      {
        (groupId === 6 && type === 2) && <Div display='flex' flexDirection='column' alignItems='center' margin='16px 0 0'>
          <Radio.Group value={byMonth} size="large" onChange={e => setByMonth(e.target.value)}>
            <Radio.Button value={0}>ปกติ</Radio.Button>
            <Radio.Button value={1}>รายเดือน</Radio.Button>
          </Radio.Group>
        </Div>
      }
      {
        (groupId === 6 && byMonth === 1) && <Div display='flex' flexDirection='column' alignItems='center' margin='16px 0 0'>
          <DatePicker.MonthPicker placeholder='เลือกเดือน' onChange={(e) => {
            setDate(moment(e).startOf('month').format('YYYY-MM-DD'))
          }} style={{ width: '100%' }} />
        </Div>
      }
      {
        (_.includes([1, 17], groupId) && type === 2) && <Div display='flex' flexDirection='column' alignItems='center' margin='16px 0 0'>
          <DatePicker.MonthPicker placeholder='เลือกเดือน' onChange={(e) => {
            setDate(moment(e).startOf('month').format('YYYY-MM-DD'))
          }} style={{ width: '100%' }} />
        </Div>
      }
      {
        (groupId === 18 && type === 2) && <Div display='flex' flexDirection='column' alignItems='center' margin='16px 0 0'>
          <Div display='flex' flexDirection='column' alignItems='center' margin='16px 0 0'>
            <DatePicker.RangePicker
              format='YYYY-MM-DD'
              onChange={(e) => {
                setDate({
                  startDate: moment(e[0]).format('YYYY-MM-DD'),
                  endDate: moment(e[1]).format('YYYY-MM-DD'),
                })
              }}
              style={{ width: '100%' }}
            />
          </Div>
          <Div display='flex' flexDirection='column' alignItems='center' margin='20px 0 0' style={{ width: '100%' }} >
            <Div margin='0 0 0' textAlign='left'>ค่าน้ำมัน</Div>
            <Input value={fuelCharge} onChange={e => setFuelCharge(e.target.value)} />
          </Div>
        </Div>
      }
      {
        useCargoType && sugarMolasse === 1
        && <Div display='flex' flexDirection='column' alignItems='center' margin='16px 0 0'>
          <P margin='0 0 8px' textAlign='center'>โปรดระบุประเภทสินค้า</P>
          <Select
            dropdown
            style={{ width: 300 }}
            value={productType}
            onChange={e => setProductType(e)}
          >
            {
              selectData.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
            }
          </Select>
        </Div>
      }
      {
        groupId === 12 && type === 2 && <Div display='flex' flexDirection='column' alignItems='center' margin='16px 0 0'>
          <P margin='0 0 8px' textAlign='center'>โปรดระบุ Booking Number</P>
          <Input value={booking} onChange={e => setBooking(e.target.value)} />
        </Div>
      }
    </Modal>
  )
}

export const MoneyCollectionReportModal = ({
  modal, setModal,
}) => {
  const {
    data, loading, error, fetchMore, refetch,
  } = useQuery(GET_CLIENTS)
  const [isLoading, setIsLoading] = useState(false)
  const [customerId, setCustomerId] = useState()
  const [customerName, setCustomerName] = useState()
  const [date, setDate] = useState([])
  if (loading && _.isEmpty(data)) return null
  return (
    <Modal
      title="พิมพ์รายงานการเก็บเงิน"
      visible={modal}
      destroyOnClose={true}
      onCancel={() => {
        setModal(false)
        setCustomerId()
        setDate(moment().format('YYYY-MM-DD'))
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/invoice/payment?startDate=${date.startDate}&endDate=${date.endDate}&customerId=${customerId}`,
        }).then((resp) => {
          FileDownload(resp.data, `รายงานการเก็บเงินของ${customerName} ณ วันที่ ${date.startDate} ถึงวันที่ ${date.endDate}.xlsx`)
          setModal(false)
          setCustomerId()
          setDate(moment().format('YYYY-MM-DD'))
          setIsLoading(false)
        })
      }}
      okButtonProps={{
        loading: isLoading,
        disabled: isLoading || _.isUndefined(customerId) || _.isEmpty(date),
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <P margin='8px 0 16px 0'>เลือกผู้จ้าง</P>
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <Select
          showSearch
          style={{ width: '100%' }}
          loading={loading}
          filterOption={(input, option) => option.props.companyName.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          onSelect={(e, option) => {
            setCustomerId(e)
            setCustomerName(option.props.companyName)
          }}
          onSearch={e => refetch({ companyName: e })}
          placeholder='พิมพ์เพื่อค้นหา'
        >
          {
            data.getCustomerLists.lists.map(v => <Select.Option key={v.id} value={v.id} companyName={v.companyName}>{v.companyName}</Select.Option>)
          }
        </Select>
      </Div>
      <P margin='8px 0 16px 0'>วันที่จ่าย</P>
      <DatePicker.RangePicker
        format='YYYY-MM-DD'
        onChange={(e) => {
          setDate({
            startDate: moment(e[0]).format('YYYY-MM-DD'),
            endDate: moment(e[1]).format('YYYY-MM-DD'),
          })
        }}
        style={{ width: '100%' }}
      />
    </Modal>
  )
}
